import React from "react";
import MaskedInput from "react-text-mask";
import { Controller } from "react-hook-form";
import SimpleTextInput from "@/components/shared/SimpleTextInput";

const EinField = ({ control, name = "ein" }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: "This field is required",
        pattern: { value: /^(\d{2}-\d{7})$/i, message: "Invalid EIN", },
      }}
      render={({ field: { onChange, value = "" }, fieldState }) => (
        <>
          <MaskedInput
            mask={[/\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
            showMask={false}
            value={value}
            onChange={onChange}
            render={(ref, props) => (
              <SimpleTextInput inputRef={ref} placeholder="12-3456789" {...props} />
            )}
          />
          <input type="hidden" name={name} value={value} />
          <div className="form__error--message">{fieldState.error?.message}</div>
        </>
      )}
    />
  );
};

export default EinField;
